import ReactGA from 'react-ga4';

// 初始化 GA4
export const initGA = (measurementId: string) => {
  ReactGA.initialize(measurementId);
};

// 页面访问跟踪
export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};

// 事件跟踪
export const logEvent = (category: string, action: string, label?: string) => {
  ReactGA.event({
    category,
    action,
    label
  });
};

// 用户行为跟踪
export const logUserAction = (action: string, data?: any) => {
  ReactGA.event({
    category: 'User',
    action,
    label: JSON.stringify(data)
  });
}; 